<template>
    <v-main>
        <AppBar />
        <v-layout fill-height column>
            <v-container flex-fill fluid>
                <div class="text-center pt-14 pb-22">
                    <div class="fs-22 fw-700 lightBlack--text mb-2">
                        DKDK@dkbrothers.co.kr
                    </div>
                    <div class="fs-14 secondary--text">
                        이메일 주소로 보내진 인증번호를 입력해주세요.
                    </div>
                </div>
                <v-form class="form-item" v-model="valid">
                    <label class="label fw-600">인증번호</label>
                    <div class="input-group">
                        <div class="pos-relative">
                            <v-text-field solo flat filled v-model="number" required :rules="number_rule"
                                placeholder="인증번호를 입력해주세요" />
                            <span class="time">02:59</span>
                        </div>
                        <v-btn elevation="0" :ripple="false" color="black" width="90" height="48"
                            class="fs-14 white--text ml-2" disabled>확인</v-btn>
                    </div>
                </v-form>
            </v-container>
            <div class="footer-btns">
                <BlackBtn str="확인" :disabled="true" />
            </div>
        </v-layout>
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
export default {
    data: () => ({
        valid: false,
        number: '',
    }),
    components: {
        BlackBtn,
    },
    computed: {
      number_rule () {
      return [
        v => !!v || '인증번호를 확인해주세요.',
      ]
    }
  },
};
</script>
<style lang="scss" scoped>
.pos-relative {
    flex: 1 1 auto;
}

.v-input::v-deep {
    .v-text-field__details {
        padding-left: 0;
    }
}

.time {
    position: absolute;
    right: 8px;
    top: 14px;
    color: $color-red;
    font-size: 14px;
}
</style>
